import React from "react";
import NumberInputFormControl from "../../../shared/form-controls/NumberInputFormControl";
import TextInputFormControl from "../../../shared/form-controls/TextInputFormControl";

function DecoMethodCategoryForm({ formData, setFormData }) {
  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.currentTarget.name]: event.currentTarget.value,
    });
  };

  return (
    <div className="container" style={{ textAlign: "initial" }}>
      <div className="row justify-content-md-center">
        <div className="col-md">
          <form>
            <TextInputFormControl
              label="Deco Name"
              id="name"
              name="name"
              value={formData.name}
              placeholder="Name"
              onChange={handleInputChange}
              disabled={true}
            />
            <NumberInputFormControl
              label="Colors Max"
              id="colorsMax"
              name="colorsMax"
              value={formData.colorsMax}
              placeholder="Colors Max"
              onChange={handleInputChange}
            />
            <TextInputFormControl
              label="Product Example"
              id="productExamples"
              name="productExamples"
              value={formData.productExamples}
              placeholder="Product Example"
              onChange={handleInputChange}
            />
          </form>
        </div>
      </div>
    </div>
  );
}

export default DecoMethodCategoryForm;
